import Vue from 'vue'
import './mixins/directives'
import router from './router'
import store from './store'
import ZJUtils from './utils'
import ZJConfig from './config'
import ZJTheme from './theme'
import ZJApis from './api'
import ZJUser from './user'
import ZJMenu from './menu'
import ZJPlugins from './plugins'
import components from './components'
import views from './views'
import emitter from './mixins/emitter'
import ZJNotify from './notify'
import ZJPlayer from './player'
import ZJMeeting from './meeting'
import log from './mixins/log'
import  '@supermap/vue-iclient3d-webgl/dist/styles/vue-iclient3d-webgl.min.css';
import VueiClient from '@supermap/vue-iclient3d-webgl';

const global = ZJUtils.global;

const ZJApp = global.ZJApp = global.ZJApp || (function(){
    function ZJApp() {
        ZJUtils.WildEmitter.call(this);
    }
    ZJUtils.WildEmitter.mixin(ZJApp);
    return new ZJApp();
})();

let vm = null;

const cmps = {
    Vue,
    router,
    store,
    ...components,
    ...views,
    ZJUtils,
    ZJConfig,
    ZJNotify,
    ZJPlayer,
    ZJMeeting,
    ZJTheme,
    ZJApis,
    ZJUser,
    ZJMenu,
    ZJPlugins
};

// 响应式扩展对象的属性
const reactiveExtend = ZJUtils.reactiveExtend = function () {
    let target = arguments[0] || {};
    for (let i = 1; i < arguments.length; i++) {
        let obj = arguments[i];
        if (obj) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    Vue.set(target, key, obj[key]);
                }
            }
        }
    }
    return target;
}

const install = function(Vue) {
    Vue.prototype.$zjapp = ZJApp;
    Vue.reactiveExtend = reactiveExtend;
    Vue.use(ZJConfig);
    Vue.use(ZJTheme);
    Vue.use(ZJUser);
    Vue.use(ZJMenu);
    //超图三维组件
    Vue.use(VueiClient);
    Vue.use(ZJNotify, {
        config: ZJConfig.current,
        user: ZJUser.current
    });
    Vue.use(ZJPlayer, {
        config: ZJConfig.current,
        user: ZJUser.current
    });
    Vue.use(ZJMeeting, {
        config: ZJConfig.current,
        user: ZJUser.current
    });
    Vue.mixin(emitter);
    Vue.use(components);
    Vue.use(views);
    Vue.mixin(log);
}

// const updateRootFontSize = function() {
//     // 计算 rem 的基量
//     let x = ()=>document.documentElement.style.fontSize
//         = (10 * window.innerWidth / 1920) + 'px';
//     let timer;
//     let last = 0;
//     x();
//     window.onresize = function() {
//         let now = new Date().getTime();
//         if (last > now - 100) {
//             clearTimeout(timer);
//         }
//         last = now;
//         timer = setTimeout(function() {
//             x();
//         }, 100);
//     };
// };

const startup = function(opts) {
    return new Promise(function (resolve, reject) {
        try {
            opts = opts || {};

            //updateRootFontSize();

            vm = new Vue({
                router,
                store,
                render: h => h(views.ZjApp)
            }).$mount(opts.el || '#app');

            global.$app = vm;
            
            resolve(vm);
        }
        catch(e) {
            reject(e);
        }
    })
}

const bootstrap = function(opts) {
    if (vm) {
        return Promise.resolve(vm);
    }
    return ZJUtils.waitAll([
            ()=>ZJConfig.current.load(opts),
            ()=>ZJTheme.current.load(opts),
            ()=>startup(opts)
        ],
        r=>r[r.length-1]
    );
}

Vue.config.productionTip = false;

/* istanbul ignore if */
if (global && global.Vue) {
    install(window.Vue);
}

ZJUtils.extend(ZJApp, {
    ...cmps,
    bootstrap,
    install,
});

export default ZJApp;